import { IBookingInfoContext, IBookingInfoProvider } from "../interface/IBookingInfoContext";
import { createContext, useEffect } from "react";
import { useMergeState } from "@core/idtek-component";
import IBookingData from "../interface/IBooking";
import _ from "lodash";
import AppUtil from "../util/AppUtil";
import { BookingApi } from "../module/booking/Constant";

export const BookingInfoContext = createContext<IBookingInfoContext | undefined>(undefined);

export const BookingInfoProvider = ({ children }: IBookingInfoProvider): JSX.Element => {
    const [bookingInfoState, setBookingInfoState] = useMergeState<IBookingData>({})
    // useEffect(() => {
    //     postCacheBooking()
    // }, [bookingInfoState])

    useEffect(() => {
        // console.log(bookingInfoState, "log in context")
    }, [bookingInfoState])

    const postCacheBooking = async () => {
        // will note cache if have bookingData from API
        if (!_.isEmpty(bookingInfoState) && bookingInfoState.bookingDataFromApi === undefined) {
            const sectionInStore = localStorage.getItem("SessionCacheId")
            const params = {
                ...bookingInfoState,
                sessionCacheId: sectionInStore
            }
            const res = await AppUtil.postApi(BookingApi.postCache, params)
            if (_.get(res, 'data.success')) {
                const newSectionId = _.get(res, 'data.result')
                localStorage.setItem('SessionCacheId', newSectionId);
            }
        }

    }

    return (
        <BookingInfoContext.Provider value={{ bookingInfoState, setBookingInfoState }}>
            {children}
        </BookingInfoContext.Provider>
    );
}

